/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"collectSmsContainer":"collect-sms_collect-sms-container__hm5Oo"};